const initialState = window.init_data;
const initList = (initialState && initialState[7] && initialState[7].list) || [];
export default function ads(state = initList, action) {
  return state;
}